/**
 * Rollup status for a purchase-order-receipt or one of its detail
 * lines. Pure derivation from the underlying exception statuses
 * (see `purchaseOrderReceiptDispositionStatus.ts` /
 * `purchaseOrderReceiptStatus.ts` in libs/core/utils).
 *
 * - `CLEAN` — no exceptions on the row (or none ever existed)
 * - `HAS_OPEN_EXCEPTIONS` — at least one exception is in a non-terminal
 *   state (OPEN / VENDOR_NOTIFIED / CREDIT_PENDING / CREDIT_RECEIVED /
 *   REPLACEMENT_PENDING / REPLACEMENT_RECEIVED). Drives the "Open
 *   Issues" tabs on Receipts and the "Outstanding Vendor Issues" tab
 *   on POs.
 * - `RESOLVED` — at least one exception ever existed, and all are
 *   in a terminal state (RESOLVED / WRITTEN_OFF). Distinguishes from
 *   CLEAN so we can show "previously had issues, all closed" in the
 *   audit trail and resolved-receipts widgets.
 *
 * Stored as varchar (not MySQL enum) for forward-compat — same
 * convention as `inventory_movement.type`. Default is `CLEAN`.
 */
export enum PurchaseOrderReceiptDispositionStatus {
	CLEAN = 'CLEAN',
	HAS_OPEN_EXCEPTIONS = 'HAS_OPEN_EXCEPTIONS',
	RESOLVED = 'RESOLVED',
}

export type PurchaseOrderReceiptDispositionStatusValue =
	`${PurchaseOrderReceiptDispositionStatus}`;

export const PurchaseOrderReceiptDispositionStatusLabels: Record<
	PurchaseOrderReceiptDispositionStatus,
	string
> = {
	[PurchaseOrderReceiptDispositionStatus.CLEAN]: 'Clean',
	[PurchaseOrderReceiptDispositionStatus.HAS_OPEN_EXCEPTIONS]: 'Open Issues',
	[PurchaseOrderReceiptDispositionStatus.RESOLVED]: 'Resolved',
};
